import React, {
  FC,
  CSSProperties,
  useState,
  ChangeEvent,
  useEffect,
  memo,
} from 'react';
import PitToolTip from '../PitToolTip/PitToolTip';
import PitBimWinRange from '../PitBimWinRange/PitBimWinRange';
import PitBimwinDialog from '../PitBimwinDialog/PitBimwinDialog';
import PitModuleShortcut from './PitShortcut';
import PitModuleRoamRoute from './PitModuleRoamRoute';
import { Platform } from 'bimwin-api';
import styles from '../../styles/app.module.scss';
import xian1 from '../../assets/images/xian1.png';
import xian from '../../assets/images/xian.png';
import manyou2 from '../../assets/images/manyou2.png';
import manyou3 from '../../assets/images/manyou3.png';
interface PitRoamProps {
  style?: CSSProperties;
  platform: Platform;
  close(): void;
}
const PitRoam: FC<PitRoamProps> = memo(({ style, platform, close }) => {
  let [lightValue, setlightValue] = useState('1');
  let [firstPersonRoamRoute, setfirstPersonRoamRoute] = useState(false);
  let [shortcut, setshortcut] = useState(true);
  const lightValueChang = (e: ChangeEvent<HTMLInputElement>) => {
    setlightValue(e.target.value);
  };
  const _setFirstPersonRoamRoute = (flag?: Boolean) => {
    setfirstPersonRoamRoute(preVal => (flag === false ? false : !preVal));
  };
  const _setshortcut = () => {
    setshortcut(preVal => !preVal);
  };
  const leaveGldBfFirstPerson = () => {
    close && close();
    setlightValue('1');
    platform.Roam.stopRoam();
    platform.Roam.setSpeed(1);
    // setisShowRootMenu(() => true);
    // setisShowFirstPersonMenu(() => false);
    setshortcut(() => false);
    setfirstPersonRoamRoute(false);
  };
  useEffect(() => {
    platform.Roam.startRoam();
  }, []);
  useEffect(() => {
    platform.Roam.setSpeed(Number(lightValue));
  }, [lightValue]);
  return (
    <div>
      <div className="pit-toolbar pit-toolbar-bottom" style={{ ...style }}>
        <div
          className="pit-toolbar-bottom-item"
          style={{
            width: 'fit-content',
            color: '#fff',
            paddingRight: '5px',
            minWidth: 0,
            minHeight: 0,
            left: '50%',
            bottom: '2px',
            display: 'block',
          }}
        >
          <PitToolTip context="移动速度">
            <div className="pit-bim-win-roam">
              <div className="pit-bim-win-roam-range">
                <PitBimWinRange value={lightValue} onChange={lightValueChang} />
              </div>
              <span className="pit-bim-win-roam-range-text">{lightValue}X</span>
            </div>
          </PitToolTip>
        </div>
        <div
          className="pit-toolbar-bottom-item"
          style={{
            width: 'fit-content',
            paddingRight: '5px',
            color: '#fff',
            left: '60%',
            bottom: '2px',
            display: 'block',
          }}
        >
          <div className="pit-panel-body">
            <div className="pit-panel-header"></div>
            <div className="pit-panel-container pit-scroll-bar pit-flex">
              <div className={styles['pit-person']}>
                <PitToolTip context="路径漫游">
                  <div className={styles['pit-walk-button']}>
                    <div
                      className={`pit-button pit-route ${
                        firstPersonRoamRoute ? 'active' : ''
                      }`}
                      onClick={() => _setFirstPersonRoamRoute()}
                    >
                      {firstPersonRoamRoute ? <img src={xian} alt="" /> : ''}
                      {!firstPersonRoamRoute ? <img src={xian1} alt="" /> : ''}
                    </div>
                  </div>
                </PitToolTip>
                <PitToolTip context="操作快捷键">
                  <div className="pit-walk-button">
                    <div
                      className={`pit-button pit-route ${
                        shortcut ? 'active' : ''
                      }`}
                      onClick={_setshortcut}
                    >
                      {shortcut ? (
                        <img src={manyou2} alt="" />
                      ) : (
                        <img src={manyou3} alt="" />
                      )}
                    </div>
                  </div>
                </PitToolTip>
                <span
                  className="pit-button-prisim pit-button"
                  onClick={leaveGldBfFirstPerson}
                >
                  退出
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- 漫游路径 --> */}
      <PitBimwinDialog
        visible={firstPersonRoamRoute}
        title="漫游路径"
        style={{
          right: '10px',
          top: '120px',
          width: '300px',
          height: '354px',
        }}
        beforeClose={_setFirstPersonRoamRoute.bind(null, false)}
      >
        <PitModuleRoamRoute platform={platform} />
      </PitBimwinDialog>
      {/* <!-- 操作快捷键 --> */}
      <PitBimwinDialog
        isResiz
        visible={shortcut}
        title="操作快捷键"
        style={{
          right: '10px',
          bottom: '120px',
          width: '300px',
          height: '240px',
        }}
        beforeClose={_setshortcut}
      >
        <PitModuleShortcut />
      </PitBimwinDialog>
    </div>
  );
});
export default PitRoam;
